export const FEEDBACK_TEXTAREA_MAX_LENGTH = 256;

export const FEEDBACK_REASONS = [
  { value: 'missing_information', label: 'Missing information' },
  { value: 'formatting_incorrect', label: 'Formatting incorrect' },
  { value: 'wrong_information', label: 'Wrong information' },
] as const;
